module.exports = __webpack_public_path__ + "static/media/blog-administracion-sistemas-programacion-8000.e5ec6e60.jpg";